module.exports = __webpack_public_path__ + "img/P150T_weapon_65.88e0a731.png";